var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { FieldsetControl, ModalV2, ModalV2Content, ModalV2Title, RadioControl } from "../../../index";
import light from "@gouvfr/dsfr/dist/artwork/light.svg";
import dark from "@gouvfr/dsfr/dist/artwork/dark.svg";
import system from "@gouvfr/dsfr/dist/artwork/pictograms/system/system.svg";
import { useThemeContext } from "./DisplayTheme.context";
var ThemeModal = forwardRef(function (_a, ref) {
    var _b, _c, _d;
    var id = _a.id, onClose = _a.onClose, className = _a.className, style = _a.style, otherProps = __rest(_a, ["id", "onClose", "className", "style"]);
    var _e = useThemeContext(), setScheme = _e.setScheme, scheme = _e.scheme;
    var onChangeTheme = function (event) {
        setScheme(event.target.value);
    };
    var idModalTitle = id + "-title";
    return (React.createElement(ModalV2, __assign({}, otherProps, { className: className, style: style, ref: ref, id: id, idModalTitle: idModalTitle, size: "sm", onClose: onClose }),
        React.createElement(ModalV2Content, null,
            React.createElement(ModalV2Title, { id: idModalTitle }, "Param\u00E8tres d'affichage"),
            React.createElement("div", { className: "fr-display" },
                React.createElement(FieldsetControl, { id: id + "-legend", legend: "Choisissez un th\u00E8me pour personnaliser l\u2019apparence du site." },
                    React.createElement(RadioControl, { id: id + "-light", name: "fr-radios-theme", label: "Th\u00E8me clair", value: "light", svg: (_b = light.src) !== null && _b !== void 0 ? _b : light, checked: scheme === "light", onChange: onChangeTheme }),
                    React.createElement(RadioControl, { id: id + "-dark", name: "fr-radios-theme", label: "Th\u00E8me sombre", value: "dark", svg: (_c = dark.src) !== null && _c !== void 0 ? _c : dark, checked: scheme === "dark", onChange: onChangeTheme }),
                    React.createElement(RadioControl, { id: id + "-system", name: "fr-radios-theme", label: "Syst\u00E8me", value: "system", svg: (_d = system.src) !== null && _d !== void 0 ? _d : system, checked: scheme === "system", onChange: onChangeTheme }))))));
});
export default ThemeModal;
